import { FormEvent, useState } from "react";
import { Alert, Form } from "react-bootstrap";
import { MdLockOutline } from "react-icons/md";
import { AxiosError } from "axios";

import { Button } from "../../components";
import { useLogin } from "./auth.api";

import styles from "./login-form.module.scss";

const getLoginErrorMessage = (error: unknown) => {
  if (error instanceof AxiosError && error.response?.status === 500) {
    return "Logowanie nie jest skonfigurowane po stronie serwera.";
  }

  if (error instanceof AxiosError && error.response?.status === 401) {
    return "Nieprawidlowa nazwa uzytkownika lub haslo.";
  }

  return "Nie udalo sie zalogowac. Sprobuj ponownie.";
};

export const LoginForm = () => {
  const { mutate: login, status, error } = useLogin();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    login({ username, password });
  };

  return (
    <section className={styles.loginFormWrapper}>
      <div className={styles.loginFormHeader}>
        <div className={styles.loginFormIconWrapper}>
          <MdLockOutline className={styles.loginFormIcon} />
        </div>
        <div>
          <h1 className={styles.loginFormTitle}>Skaner katalogow</h1>
          <p className={styles.loginFormSubtitle}>Zaloguj sie, aby przetwarzac katalogi.</p>
        </div>
      </div>
      <Form className={styles.loginForm} onSubmit={handleSubmit}>
        <Form.Group controlId="username">
          <Form.Label>Nazwa uzytkownika</Form.Label>
          <Form.Control
            autoComplete="username"
            name="username"
            required
            type="text"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
          />
        </Form.Group>
        <Form.Group controlId="password">
          <Form.Label>Haslo</Form.Label>
          <Form.Control
            autoComplete="current-password"
            name="password"
            required
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </Form.Group>
        {status === "error" && <Alert variant="danger">{getLoginErrorMessage(error)}</Alert>}
        <Button className={styles.loginButton} isProcessing={status === "pending"} type="submit">
          Zaloguj
        </Button>
      </Form>
    </section>
  );
};
